<template>
    <vue-scroll>
        <div class="page-header">
            <h1>Order History</h1>
        </div>
        <div class="float-right">
            Filter:
            <el-date-picker
                v-model="date_filter"
                type="date"
                placeholder="Filter Date"
                @change="onChangeDateFilter"
                :picker-options="dateFilterOptions"
            >
            </el-date-picker>
        </div>
        <div class="clearfix"></div>
        <el-table class="mt-20" :data="items.data" v-loading="loading">
            <el-table-column
                prop="id"
                width="160px"
                label="Order Number"
                sortable
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.id }}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="Issue"
                prop="formatted_issue"
                sortable
                width="160px"
            />
            <el-table-column prop="created_at" label="Date" sortable>
                <template slot-scope="scope">
                    {{ scope.row.created_at | short_datetime }}
                </template>
            </el-table-column>
            <el-table-column prop="detailed_status" label="Status" sortable>
                <template slot-scope="scope">
                    <span
                        :class="`${scope.row.detailed_status
                            .replace(/\s+/g, '-')
                            .toLowerCase()}-status`"
                        >{{ scope.row.detailed_status }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column prop="payment_status" label="Invoice">
                <template slot-scope="scope">
                    <span
                        :class="`${scope.row.payment_status
                            .toLowerCase()
                            .replace(/\s+/g, '-')}-status`"
                        >{{ scope.row.payment_status }}</span
                    ><span
                        style="padding-left: 10px"
                        v-if="!current_community.is_bill_to_account_only"
                    >
                        <el-button
                            type="danger"
                            icon="mdi mdi-credit-card"
                            v-if="
                                scope.row.payment_status != 'Paid' &&
                                scope.row.has_sage_invoice
                            "
                            @click="getPaymentUrl"
                            >Pay Now</el-button
                        ></span
                    >
                </template>
            </el-table-column>
            <el-table-column label="Tracking Info">
                <template slot-scope="{ row }" v-if="row.is_closed">
                    <a :href="`/web-api/order/${row.id}/track`" target="_blank"
                        >Track Your Order <i class="mdi mdi-open-in-new"
                    /></a>
                </template>
            </el-table-column>
            <el-table-column
                prop="approval_status"
                width="120px"
                label="Approval"
                sortable
            >
                <template slot-scope="scope">
                    <el-tag
                        type="success"
                        v-if="
                            scope.row.approval_status ===
                            ApprovalStatus.APPROVED
                        "
                        ><i class="el-icon-check" /> Approved
                    </el-tag>
                    <el-tag
                        type="danger"
                        v-else-if="
                            scope.row.approval_status ===
                            ApprovalStatus.REJECTED
                        "
                        ><i class="mdi mdi-close" /> Rejected
                    </el-tag>
                    <el-tag type="warning" v-else>Pending</el-tag>
                </template>
            </el-table-column>
            <el-table-column prop="actions" width="120px">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button
                            icon="mdi mdi-eye"
                            @click="viewItem(scope.row)"
                            >View</el-button
                        >
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <app-pagination
            :disabled="loading"
            class="mt-10"
            :pagination="items.meta.pagination"
            v-if="items.meta.pagination"
            @current-change="onCurrentChange"
        />
    </vue-scroll>
</template>

<script>
import qs from "qs";
import { mapState } from "vuex";
import * as ApprovalStatus from "../../../constants/approval-status";

export default {
    data() {
        return {
            ApprovalStatus,
            dialogVisible: false,
            form: new Form({
                name: null,
                slug: null,
                logo: null,
                location: {
                    street: null,
                    city: null,
                    state: null,
                    zip: null
                }
            }),
            filter: {
                created_at: null
            },
            date_filter: null,
            logo_src: null,
            editingItem: null,
            loading: false,
            dateFilterOptions: {
                shortcuts: [
                    {
                        text: "Today",
                        onClick(picker) {
                            picker.$emit("pick", new Date());
                        }
                    },
                    {
                        text: "Yesterday",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit("pick", date);
                        }
                    },
                    {
                        text: "A week ago",
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", date);
                        }
                    }
                ]
            },
            items: {
                data: [],
                meta: {
                    pagination: null
                }
            }
        };
    },
    computed: {
        ...mapState({
            current_community: (state) => state.current_community
        })
    },
    mounted() {
        this.getData({ page: 1 });
    },
    methods: {
        getData({ page = 1 }) {
            this.loading = true;
            let params = {
                include: this.$store.state.orders.meta.include,
                page,
                sort_by: "created_at",
                sort_order: "desc",
                filter: this.filter
            };

            axios
                .get(`/web-api/order?${qs.stringify(params)}`)
                .then((response) => {
                    this.items.data = response.data.data;
                    this.items.meta.pagination = response.data.meta.pagination;
                })
                .finally(() => (this.loading = false));
        },
        viewItem(item) {
            this.$router.push({
                name: "ViewOrder",
                params: {
                    id: item.id
                }
            });
        },
        onChangeDateFilter(date) {
            this.filter.created_at = date
                ? moment(date).format("YYYY-MM-DD")
                : null;
            this.getData({ page: 1 });
        },
        onCurrentChange(page) {
            this.getData({ page });
        },
        async getPaymentUrl() {
            try {
                const response = await fetch(`/web-api/payment-url`);
                const data = await response.json();
                const paymentUrl = data.payment_url;
                window.open(`${paymentUrl}`, "_blank");
            } catch (error) {
                console.error("Error copying payment URL:", error);
            }
        }
    }
};
</script>

<style scoped>
.printed-status {
    color: #606266;
}
.designed-status {
    color: #86b142;
}
.printing-status {
    color: #1c41c9;
}
.pdf-approved-status {
    color: #c2111b;
}
.pdf-emailed-status {
    color: #d34ad5;
}
.proofed-status {
    color: #6385d8;
}
.paid-status {
    color: #008000;
}
.due-status {
    color: #0000ff;
}
.overdue-status {
    color: #ff0000;
}
</style>
